var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13.224,
  height: 13.18
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -0.85)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0.85)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.59,12.931H1.647a.549.549,0,0,1-.549-.549V2.5a.549.549,0,0,1,.549-.549H6.59a.549.549,0,0,0,0-1.1H1.647A1.649,1.649,0,0,0,0,2.5v9.885A1.649,1.649,0,0,0,1.647,14.03H6.59a.549.549,0,0,0,0-1.1Z",
  transform: "translate(0 -0.85)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.393 3.596)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M178.767,110.618l-3.339-3.295a.549.549,0,0,0-.771.782l2.386,2.355h-6.394a.549.549,0,0,0,0,1.1h6.394l-2.386,2.355a.549.549,0,1,0,.771.782l3.339-3.295a.549.549,0,0,0,0-.782Z",
  transform: "translate(-170.1 -107.165)"
})))));
export { SvgLogout as ReactComponent };